import * as React from 'react';
import './Preview.css';

interface PreviewProps {
  previewText: string;
}

interface PreviewState {
  scrollTop: number;
}

export class Preview extends React.Component<PreviewProps, PreviewState> {
  constructor(props: PreviewProps) {
    super(props);
    this.state = { scrollTop: 0 };
  }

  public render() {
    return (
      <div id="preview" style={this.style}>
        <h2><span>プレビュー</span></h2>
        <pre className={this.className}>
          {this.props.previewText}
        </pre>
      </div>
    );
  }

  public componentDidMount() {
    window.addEventListener('scroll', () => this.updateScrollTop());
  };

  private updateScrollTop() {
    const scrollTop = Math.max(
      document.body.scrollTop,
      window.pageYOffset,
      document.documentElement.scrollTop
    );
    this.setState({ scrollTop });
  }

  private get className() {
    return this.props.previewText ? '' : 'Empty';
  }

  private get style() {
    return {
      transform: `translateY(${this.state.scrollTop}px)`
    };
  }
}